import type { ProductFilterValues } from '~/features/catalog-operations/types/catalog-operations.types';

/** Counts how many filter keys carry a meaningful selection. Arrays count by
 *  length; strings count as 1 when non-blank; booleans count when truthy — an
 *  applied-filters object routinely holds empty arrays and blank strings, so
 *  `Object.keys().length` would over-report. Drives both the Filter button's
 *  badge and the products page's "is this list narrowed?" check. */
export function countAppliedFilters(filters: ProductFilterValues): number {
  let count = 0;
  for (const value of Object.values(filters)) {
    if (Array.isArray(value)) count += value.length;
    else if (typeof value === 'string') {
      if (value.trim()) count += 1;
    } else if (value) {
      count += 1;
    }
  }
  return count;
}
